import { useSubscription, useApolloClient } from '@apollo/client';
import { NotificationUpdatedPayload } from '@bechtel/types';
import { useEffect } from 'react';
import { SUBSCRIPTION_EVENT_NOTIFICATION_UPDATED } from '@bechtel/client-gql';
import { useEventNotificationsCache } from '../use-event-notifications-cache';

export function useSyncNotificationSubscription() {
  const { data: syncSubscriptionData } = useSubscription<{ notificationUpdated: NotificationUpdatedPayload }>(
    SUBSCRIPTION_EVENT_NOTIFICATION_UPDATED
  );
  const { updateEventNotificationsCache } = useEventNotificationsCache();
  const client = useApolloClient();

  useEffect(() => {
    const fetchEventNotificationsStats = async () => {
      await client.refetchQueries({
        include: ['eventNotificationStats'],
      });
    };
    if (
      !syncSubscriptionData ||
      !syncSubscriptionData.notificationUpdated ||
      !syncSubscriptionData.notificationUpdated.id
    )
      return;
    updateEventNotificationsCache([syncSubscriptionData.notificationUpdated.id]);
    fetchEventNotificationsStats();
  }, [syncSubscriptionData]);

  return null;
}
